import { animate, MotionStyle, useMotionValue } from 'framer-motion';
import { useEffect } from 'react';

const DEFAULT_DURATION = 0.2;

interface IUseReorderItemDragStyle {
  direction: 'x' | 'y';
  boxShadow?: {
    active: string;
    inactive: string;
    duration?: number;
  };
  // Add other styles to animate as needed
}

export const useReorderItemDragStyle = ({
  direction,
  boxShadow,
}: IUseReorderItemDragStyle): MotionStyle => {
  const target = useMotionValue(0);

  const boxShadowMotionValue = useMotionValue(boxShadow?.inactive);

  useEffect(() => {
    let isActive: boolean = false;

    const animateBoxShadow = (latest: number) => {
      if (!boxShadow) {
        return;
      }

      const wasActive = isActive;
      isActive = latest !== 0;

      if (isActive !== wasActive) {
        animate(
          boxShadowMotionValue,
          isActive ? boxShadow.active : boxShadow.inactive,
          {
            duration: boxShadow.duration ?? DEFAULT_DURATION,
          }
        );
      }
    };

    const unsubscribe = target.on('change', animateBoxShadow);

    return () => {
      unsubscribe();
    };
  }, []);

  return { [direction]: target, boxShadow: boxShadowMotionValue };
};
